import {Button} from '@dropbox/dig-components/buttons';
import {LookMagnifyingGlassSpot} from '@dropbox/dig-illustrations';
import {analyticsLogger} from 'analytics/analyticsLogger';
import {getNavigationContext, updateRouterNavigationType} from 'analytics/navigationInfo';
import {getAnonymizedRoute} from 'analytics/routeInfo';
import {NonIdealState} from 'components/shared/NonIdealState';
import {useDocumentTitle} from 'hooks/useDocumentTitle';
import {t} from 'i18next';
import {useEffect} from 'react';
import {useLocation, useNavigationType} from 'react-router';

const NotFound = () => {
  useDocumentTitle(t('not_found'));
  const location = useLocation();
  const routerNavigationType = useNavigationType();

  useEffect(() => {
    updateRouterNavigationType(routerNavigationType);
    analyticsLogger().logEvent('NOT_FOUND_PAGE_VIEWED', {
      route: getAnonymizedRoute(),
      ...getNavigationContext(routerNavigationType),
    });
  }, [location.key, routerNavigationType]);

  return (
    <>
      <NonIdealState
        image={<LookMagnifyingGlassSpot />}
        title={t('we_cant_find_the_page_youre_looking_for')}
        description={t('check_the_url_and_try_again')}
        action={
          <Button href={window.location.origin} variant="primary">
            {t('go_back_home')}
          </Button>
        }
      />
    </>
  );
};

export {NotFound};
